export default {
  name: "HomeSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M29.93 15.37A1 1 0 0 1 29 16h-2v11a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-5h-4v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V16H3c-.88.03-1.34-1.14-.69-1.72L14.63 2.54a2.01 2.01 0 0 1 2.72-.01l12.33 11.75c.31.28.4.71.25 1.09z",
  },
}
